import React, { useContext, useEffect, useRef, useState } from 'react';
import debounce from 'debounce';

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography';

import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';
import { ServiceDateInput } from '../../booking/dates/ServiceDateInput';
import Alert from '@material-ui/lab/Alert';
import MemberMiniMenu from '../menus/MemberMiniMenu';

const newAbsence = () => {
    return { description: '', dateConstraint: { type: 'dateRange', values: [] } }
}

const AbsenceInput = ({ value, index, onChange, onDelete }) => {
    const [activeRow, setActiveRow] = useState(-1);
    const [absence, setAbsence] = useState(value);
    const descriptionRef = useRef();

    const handleChange = debounce(fragment => {
        const updated = {...absence, ...fragment};

        onChange(updated);
        setAbsence(updated);
    }, 500);

    return (
        <Paper style={{ padding: '1rem' }} onMouseEnter={() => setActiveRow(index)} onMouseLeave={() => setActiveRow(-1)}>
            <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs={12} lg={6}>
                    <ServiceDateInput
                        label="Date(s)"
                        dateConstraint={absence.dateConstraint}
                        onChange={(value) => handleChange({dateConstraint: value})}
                        byDate={false}
                    />

                </Grid>
                <Grid item xs={12} lg={6}>
                    <TextField
                        defaultValue={absence.description}
                        inputRef={descriptionRef}
                        onChange={() => handleChange({description: descriptionRef.current.value})}
                        label="Description"
                        placeholder="Reason for unavailability"
                        style={{
                            marginTop: '1rem',
                            minWidth: '50ch'
                        }}
                        fullWidth
                    />
                </Grid>
                <Grid item>
                    {
                        activeRow === index ? <Button variant="outlined" color="secondary" onClick={onDelete} style={{marginTop: '1.5rem'}}>DELETE THESE DATES</Button> : <></>
                    }
                </Grid>
            </Grid>
        </Paper>
    );
}

const MemberAvailabilityContent = ({ unavailable, onChange }) => {
    const [absences, setAbsences] = useState(unavailable?.length ? unavailable : [newAbsence()]);

    const handleChange = (index, value) => {
        const updated = absences.map((item, i) => {
            return index === i ? value : item;
        })

        onChange({ unavailable: updated });
        setAbsences(updated);
    }

    const addNewRow = () => {
        setAbsences([...absences, newAbsence()]);
    }

    const deleteRow = row => {
        const updated = absences.filter((_, index) => index !== row);
        setAbsences(updated);
        onChange({ unavailable: updated});
    }

    return (
        <div style={{ padding: '1rem' }}>
            <Typography variant="h5" color="initial" gutterBottom>Dates when you're not available 🏖️</Typography>
            <Alert variant="outlined" severity="info">
            If there are dates when you know you may not want to work such as school holidays, training courses etc. you can enter the dates below
            </Alert>
            <div style={{ marginTop: '1rem' }}>
                {
                    absences.map((absence, index) => {
                        return (
                            <div style={{ marginTop: '1rem' }} key={`absence-${index}`}>
                                <AbsenceInput value={absence} onChange={value => handleChange(index, value)} onDelete={() => deleteRow(index)} />
                            </div>
                        )
                    })
                }
            </div>
            <div style={{ marginTop: '1rem' }}>
                <Button variant="contained" color="primary" onClick={addNewRow}>
                    Add another row
                </Button>
            </div>
        </div>
    );
}

const MemberAvailabilityPage = () => {
    const { currentUser } = useContext(AuthContext);
    const path = `intermediaries/${currentUser.uid}`;

    // console.log('path', path)

    const db = useContext(FireDataContext);
    const [member, setMember] = useState();

    useEffect(() => {
        db.get({ path })
            .then(user => {
                if (user) {
                    setMember(user);
                }
                else {
                    setMember({
                        id: currentUser.uid,
                        unavailable: []
                    });
                }
            })
            .catch(error => {
                console.log('MemberProfilePage db.get >', error);
            })

    }, [db, currentUser.uid, path]);

    if (!member) return <></>;

    const handleChange = fragment => {
        db.update({
            path: `intermediaries/${currentUser.uid}`,
            payload: fragment
        })
    }

    return (
        <MemberMiniMenu>
            <MemberAvailabilityContent unavailable={member?.unavailable} onChange={handleChange} />
        </MemberMiniMenu>
    )
};

export default MemberAvailabilityPage;